import React, { useMemo, useState } from "react";
import { useFormikContext } from "formik";
import { Box, Tabs, Tab, Typography } from "@mui/material";

import StepDetailsForm from "./StepDetailsForm";
// Step 6 + 7 will implement these
import StepRejectForm from "./StepRejectForm";
import ChildStepsEditor from "./ChildStepsEditor";
import StepApprovelForm from "./StepApprovelForm";

export default function AddStepEditor({ roles = [], selectedStepIndex }) {
    const { values } = useFormikContext();
    const steps = values?.steps || [];

    const step = useMemo(() => steps?.[selectedStepIndex] || null, [steps, selectedStepIndex]);
    const [tab, setTab] = useState(0);

    if (!steps.length) {
        return (
            <Box>
                <Typography sx={{ fontSize: 14, opacity: 0.75 }}>
                    Add a step from the left panel to start configuring.
                </Typography>
            </Box>
        );
    }

    if (!step) {
        return (
            <Box>
                <Typography sx={{ fontSize: 14, opacity: 0.75 }}>
                    Select a step from the left panel.
                </Typography>
            </Box>
        );
    }

    return (
        <Box>
            <Typography sx={{ fontSize: 16, fontWeight: 600, mb: 1 }}>
                Step Configuration
            </Typography>

            <Tabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                sx={{ mb: 2 }}
            >
                <Tab label="Details" />
                <Tab label="Reject Routing" />
                <Tab label="Approval Routing" />
                <Tab label={`Child Steps (${step.childSteps?.length || 0})`} />
            </Tabs>

            {tab === 0 && (
                <StepDetailsForm roles={roles} stepIndex={selectedStepIndex} />
            )}

            {tab === 1 && (
                <Typography sx={{ fontSize: 13, opacity: 0.7 }}>
                    <StepRejectForm stepIndex={selectedStepIndex} />
                </Typography>
            )}

            {tab === 2 && (
                <Typography sx={{ fontSize: 13, opacity: 0.7 }}>
                    <StepApprovelForm stepIndex={selectedStepIndex} />
                </Typography>
            )}

            {tab === 3 && (
                <Typography sx={{ fontSize: 13, opacity: 0.7 }}>
                    <ChildStepsEditor roles={roles} stepIndex={selectedStepIndex} />
                </Typography>
            )}
        </Box>
    );
}
